import { useApi } from "utils"; 
import { useEffect, useState } from "react";
import { SetItemPriceType } from "../../types";

type FilterState = {
    page?: number,
    group_id?: string,
    limit?: number,
    keyword?: string
}

type DataListType = {
    items: SetItemPriceType[],
    pagination_data: {
        page: number,
        pages: number,
        size: number,
        total: number
    }
}


export function useList({ page = 1, group_id, limit = 10, keyword }: FilterState) {

    const defaultValue = {
        items: [],
        pagination_data: {
            page: 0,
            pages: 0,
            size: 0,
            total: 0
        }
    }

    const api = useApi();
    const [data, setData] = useState<DataListType>(defaultValue);
    const [isLoading, setLoading] = useState(true)

    const params: { [key: string]: number | string | undefined } = {}
    if (page) params.page = page;
    if (group_id) params.group_id = group_id;
    if (limit) params.limit = limit;
    if (keyword) params.keyword = keyword;

    const fetchUrl = () => {
        return api.get("/product/getitemprice?",{params})
    }

    const fetchData = () => {
        setLoading(true);

        fetchUrl().then((res) => {
            setData(res.data.payload);
        }).catch(() => {
            setData(defaultValue);
        }).finally(() => {
            setLoading(false);
        });
    }

    const refetch = () => fetchData();

    useEffect(() => {
        fetchData();

        return () => {
            setData(defaultValue);
            setLoading(true);
        }
        // eslint-disable-next-line
    }, [page, group_id, limit, keyword]);

    return { data, isLoading, refetch }
}
